// src/utils/apiUtils.js
import { API_BASE } from "@/constants/api"; // Make sure API_BASE is imported

/**
 * Builds the correct API URL for local proxy or live environment.
 * @param {string} endpointPath - The API endpoint path (e.g., 'vdb/brands/dropdown').
 * @param {URLSearchParams|Object|null} params - Query parameters.
 * @returns {string} The fully constructed API URL.
 */
export function buildApiUrl(endpointPath, params = null) {
  let url;
  // Check if API_BASE indicates the local proxy script is being used
  const isLocalProxy = API_BASE.includes('local_vdb_api.php');

  if (isLocalProxy) {
    // Local Proxy: Append endpoint path, then use '&' for subsequent params
    url = `${API_BASE}${endpointPath}`;
    if (params) {
      const queryParams = (params instanceof URLSearchParams) ? params : new URLSearchParams(params);
      const queryString = queryParams.toString();
      if (queryString) {
         url += `&${queryString}`; // Use '&'
      }
    }
  } else {
    // Live/Direct API: Append endpoint path, then use '?' for params
    url = `${API_BASE}${endpointPath}`;
    if (params) {
      const queryParams = (params instanceof URLSearchParams) ? params : new URLSearchParams(params);
      const queryString = queryParams.toString();
       if (queryString) {
         url += `?${queryString}`; // Use '?'
       }
    }
  }
  console.log(`Built API URL: ${url}`); // Keep logging for debugging
  return url;
}
